import { render, staticRenderFns } from "./DispatchHostingRequest.vue?vue&type=template&id=225636b3&scoped=true&"
import script from "./DispatchHostingRequest.vue?vue&type=script&lang=js&"
export * from "./DispatchHostingRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225636b3",
  null
  
)

export default component.exports